import { useCallback, useState } from 'react'; // interface Params {}

export default function useAddSection() {
  const {
    0: isAddingSection,
    1: setIsAddingSection
  } = useState(false);
  const {
    0: addSectionLayoutGroup,
    1: setAddSectionLayoutGroup
  } = useState('');
  const setupAddSection = useCallback(function () {
    let layoutGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setIsAddingSection(true);
    setAddSectionLayoutGroup(layoutGroup);
  }, [setIsAddingSection, setAddSectionLayoutGroup]);
  const teardownAddSection = useCallback(() => {
    setIsAddingSection(false);
    setAddSectionLayoutGroup('');
  }, [setIsAddingSection, setAddSectionLayoutGroup]);
  return {
    isAddingSection,
    addSectionLayoutGroup,
    setupAddSection,
    teardownAddSection
  };
}